import { useGraphQLQuery } from '@betterment/graphql';
import { Card, H2 } from '@betterment/samba-react';

import { ErrorBoundary } from '~/b4b/components/error-boundary/ErrorBoundary';
import { useCurrentEmployerId } from '~/b4b/utils/currentEmployer';

import { EmployerSupportDocument } from './graphql/query.getSupportContacts.generated';
import { ErrorSupportCard } from './support-card/ErrorSupportCard';
import { SupportContacts } from './support-card/SupportContacts';

const GetSupportCardQuery = () => {
  const employerId = useCurrentEmployerId();
  const { data, dataState } = useGraphQLQuery(EmployerSupportDocument, {
    variables: { employerId },
    throwOnError: true,
  });
  const contacts = dataState === 'complete' ? data.employer.support.contacts : undefined;
  return <SupportContacts contacts={contacts} />;
};

export const GetSupportCard = () => (
  <Card css={{ p: 'space.300' }}>
    <Card.Header css={{ marginBottom: 'space.300' }}>
      <H2 variant="title200">Get support</H2>
    </Card.Header>
    <Card.Content>
      <ErrorBoundary name="supportCard" renderFallback={ErrorSupportCard}>
        <GetSupportCardQuery />
      </ErrorBoundary>
    </Card.Content>
  </Card>
);
